import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@syneto/compass-react';
import { getUpgradeChannelLabel, getUpgradeChannelAppearance } from '../../../helpers/UpgradeChannelFormatter';

export const UpgradeChannelBadge = (props) => {
	const { currentUpgradeChannel } = props;

	return (
		<Badge appearance={getUpgradeChannelAppearance(currentUpgradeChannel)}>
			{getUpgradeChannelLabel(currentUpgradeChannel)}
		</Badge>
	);
};

UpgradeChannelBadge.propTypes = {
	currentUpgradeChannel: PropTypes.string,
};
